import React from "react"
import FormSection from "./FormSection"
import TextInput from "./TextInput"

export default function TimeToContact() {
  const inputs = [
    {
      label: "Full Name",
      name: "fullname_preferred_contact",
      type: "text",
    },
    {
      label: "Phone Number",
      name: "phone_preferred_contact",
      type: "text",
    },
    {
      label: "Most Suitable Time/Date",
      name: "date_preferred_contact",
      type: "text",
    },
  ]

  return (
    <FormSection
      title="Please nominate best contact person and most suitable day/time to call"
      className="bg-gray-100"
    >
      <div className="grid grid-cols-2 gap-4">
        {inputs.map(input => (
          <TextInput
            label={input.label}
            name={input.name}
            type={input.type}
            placeholder={input.placeholder}
            className="flex flex-col mr-32"
          />
        ))}
      </div>
    </FormSection>
  )
}
